import { render, staticRenderFns } from "./imgShow.vue?vue&type=template&id=04ef20b4&scoped=true&"
import script from "./imgShow.vue?vue&type=script&lang=js&"
export * from "./imgShow.vue?vue&type=script&lang=js&"
import style0 from "./imgShow.vue?vue&type=style&index=0&id=04ef20b4&prod&lang=stylus&scoped=true&"
import style1 from "./imgShow.vue?vue&type=style&index=1&id=04ef20b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ef20b4",
  null
  
)

export default component.exports